import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MessageCircle, Save, ShieldCheck } from "lucide-react";
import { cleanPhone } from "./empresaHelpers";

const fromApi = (d) => ({ whatsapp_suporte: d?.whatsapp_suporte || "", mensagem_padrao: d?.mensagem_padrao || "" });

// Configuração global de suporte (fev/2026) — WhatsApp/mensagem exibidos na tela de bloqueio de licença.
export function LicenseSupportCard({ canLoad }) {
  const [cfg, setCfg] = useState(fromApi(null));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!canLoad) return;
    api.get("/license/support-info").then((r) => setCfg(fromApi(r.data)))
      .catch((e) => console.debug("support-info indisponível", e));
  }, [canLoad]);

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put("/license/support-info", cfg);
      setCfg(fromApi(r.data));
      toast.success("Configuração de suporte salva");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao salvar configuração");
    } finally { setSaving(false); }
  };

  return (
    <Card>
      <CardHeader><CardTitle className="flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-orange-600" />Suporte de Licenciamento (global)</CardTitle></CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-3">
          Este WhatsApp e mensagem aparecem na tela de bloqueio quando alguma empresa ficar com licença inativa/expirada.
          Configure uma vez — vale para todos os tenants.
        </p>
        <div className="grid md:grid-cols-3 gap-3 items-end">
          <div>
            <Label className="text-xs">WhatsApp de suporte (com DDI)</Label>
            <div className="relative">
              <MessageCircle className="w-4 h-4 text-emerald-600 absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none" />
              <Input value={cfg.whatsapp_suporte} onChange={(e) => setCfg({ ...cfg, whatsapp_suporte: cleanPhone(e.target.value) })}
                placeholder="+5511999999999" className="pl-8 mono" data-testid="license-support-whatsapp" />
            </div>
            <p className="text-[10px] text-muted-foreground mt-1">Formato E.164 (ex: +55 + DDD + número). Sem espaços.</p>
          </div>
          <div className="md:col-span-2">
            <Label className="text-xs">Mensagem pré-preenchida <span className="text-muted-foreground">(opcional)</span></Label>
            <Input value={cfg.mensagem_padrao} onChange={(e) => setCfg({ ...cfg, mensagem_padrao: e.target.value })}
              placeholder="Olá! Preciso regularizar a licença da minha empresa." data-testid="license-support-message" />
            <p className="text-[10px] text-muted-foreground mt-1">Se vazio, uma mensagem padrão será usada.</p>
          </div>
        </div>
        <div className="flex justify-end mt-3">
          <Button onClick={save} disabled={saving} className="bg-orange-600 hover:bg-orange-700" data-testid="btn-save-license-support">
            <Save className="w-4 h-4 mr-1" />{saving ? "Salvando..." : "Salvar Suporte"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
